import JustValidate from 'just-validate';

function checkCategories() {
  const checkedItems = document.querySelectorAll('input.VogForm_VogForm_VogVolunteerGroup:checked').length;

  return (checkedItems > 0) && (checkedItems > 0);
}

if (document.querySelector('#VogForm_VogForm')) {
  const VogForm = new JustValidate('#VogForm_VogForm');

  VogForm.addField('[name="VogVolunteerGroup[Beleidscommissie]"]', [
    {
      validator: checkCategories,
      errorMessage: 'Kies minimaal 1 vrijwilligerscategorie.',
    },
  ]);
}

if (document.querySelector('#NominateForm_NominateForm')) {
  const NominateForm = new JustValidate('#NominateForm_NominateForm');

  NominateForm
    .addField('#NominateForm_NominateForm_Gender_Holder', [
      { rule: 'required' },
    ]);

  new JustValidate('#NominateForm_NominateForm');
}
